/**
 * @generated SignedSource<<5c8f872c3c82a660263576ea780ceddf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData$data = {
  readonly search: {
    readonly search: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: string;
        } | null | undefined;
      }>;
      readonly isCachedResult: boolean | null | undefined;
      readonly pageInfo: {
        readonly endCursor: string | null | undefined;
      };
      readonly " $fragmentSpreads": FragmentRefs<"searchResults_AtlassianSearchPage_SearchResultsBody_connectionData">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData";
};
export type searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData$key = {
  readonly " $data"?: searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData">;
};

import SearchResultsAsyncPaginationQuery_graphql from './SearchResultsAsyncPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "search",
  "search"
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "assetsFilters"
    },
    {
      "kind": "RootArgument",
      "name": "cloudIdARI"
    },
    {
      "kind": "RootArgument",
      "name": "commonFilters"
    },
    {
      "kind": "RootArgument",
      "name": "compassFilters"
    },
    {
      "kind": "RootArgument",
      "name": "confluenceFilters"
    },
    {
      "kind": "RootArgument",
      "name": "disableQueryReplacement"
    },
    {
      "kind": "RootArgument",
      "name": "enableHighlighting"
    },
    {
      "kind": "RootArgument",
      "name": "entities"
    },
    {
      "kind": "RootArgument",
      "name": "expectResult"
    },
    {
      "kind": "RootArgument",
      "name": "experience"
    },
    {
      "kind": "RootArgument",
      "name": "experimentId"
    },
    {
      "kind": "RootArgument",
      "name": "experimentLayers"
    },
    {
      "kind": "RootArgument",
      "name": "fanoutExperimentCohort"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAssigneeField"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeIconUrl"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeIssueTypeField"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeNavBoostScore"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePassionfruitAsk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePositions"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeThirdPartyId"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeTotalCounts"
    },
    {
      "kind": "RootArgument",
      "name": "jiraFilters"
    },
    {
      "kind": "RootArgument",
      "name": "limit"
    },
    {
      "kind": "RootArgument",
      "name": "mercuryFilters"
    },
    {
      "kind": "RootArgument",
      "name": "query"
    },
    {
      "kind": "RootArgument",
      "name": "queryVersion"
    },
    {
      "kind": "RootArgument",
      "name": "searchSessionId"
    },
    {
      "kind": "RootArgument",
      "name": "sessionId"
    },
    {
      "kind": "RootArgument",
      "name": "shadowExperimentId"
    },
    {
      "kind": "RootArgument",
      "name": "sort"
    },
    {
      "kind": "RootArgument",
      "name": "sourceProduct"
    },
    {
      "kind": "RootArgument",
      "name": "talentFilters"
    },
    {
      "kind": "RootArgument",
      "name": "tenantId"
    },
    {
      "kind": "RootArgument",
      "name": "thirdPartyFilters"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "limit",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "limit",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": SearchResultsAsyncPaginationQuery_graphql
    }
  },
  "name": "searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData",
  "selections": [
    {
      "concreteType": "SearchQueryAPI",
      "kind": "LinkedField",
      "name": "search",
      "plural": false,
      "selections": [
        {
          "alias": "search",
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "queryVersion",
                  "variableName": "queryVersion"
                },
                {
                  "kind": "Variable",
                  "name": "searchSessionId",
                  "variableName": "searchSessionId"
                },
                {
                  "kind": "Variable",
                  "name": "sessionId",
                  "variableName": "sessionId"
                },
                {
                  "kind": "Variable",
                  "name": "sourceProduct",
                  "variableName": "sourceProduct"
                }
              ],
              "kind": "ObjectValue",
              "name": "analytics"
            },
            {
              "kind": "Variable",
              "name": "disableQueryReplacement",
              "variableName": "disableQueryReplacement"
            },
            {
              "kind": "Variable",
              "name": "enableHighlighting",
              "variableName": "enableHighlighting"
            },
            {
              "kind": "Variable",
              "name": "expectResult",
              "variableName": "expectResult"
            },
            {
              "kind": "Variable",
              "name": "experience",
              "variableName": "experience"
            },
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "experimentId",
                  "variableName": "experimentId"
                },
                {
                  "kind": "Variable",
                  "name": "experimentLayers",
                  "variableName": "experimentLayers"
                },
                {
                  "kind": "Variable",
                  "name": "shadowExperimentId",
                  "variableName": "shadowExperimentId"
                }
              ],
              "kind": "ObjectValue",
              "name": "experimentContext"
            },
            {
              "kind": "Variable",
              "name": "fanoutExperimentCohort",
              "variableName": "fanoutExperimentCohort"
            },
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "assetsFilters",
                  "variableName": "assetsFilters"
                },
                {
                  "kind": "Variable",
                  "name": "commonFilters",
                  "variableName": "commonFilters"
                },
                {
                  "kind": "Variable",
                  "name": "compassFilters",
                  "variableName": "compassFilters"
                },
                {
                  "kind": "Variable",
                  "name": "confluenceFilters",
                  "variableName": "confluenceFilters"
                },
                {
                  "kind": "Variable",
                  "name": "entities",
                  "variableName": "entities"
                },
                {
                  "kind": "Variable",
                  "name": "jiraFilters",
                  "variableName": "jiraFilters"
                },
                {
                  "items": [
                    {
                      "kind": "Variable",
                      "name": "locations.0",
                      "variableName": "cloudIdARI"
                    }
                  ],
                  "kind": "ListValue",
                  "name": "locations"
                },
                {
                  "kind": "Variable",
                  "name": "mercuryFilters",
                  "variableName": "mercuryFilters"
                },
                {
                  "kind": "Variable",
                  "name": "talentFilters",
                  "variableName": "talentFilters"
                },
                {
                  "kind": "Variable",
                  "name": "thirdPartyFilters",
                  "variableName": "thirdPartyFilters"
                }
              ],
              "kind": "ObjectValue",
              "name": "filters"
            },
            {
              "kind": "Variable",
              "name": "query",
              "variableName": "query"
            },
            {
              "kind": "Variable",
              "name": "sort",
              "variableName": "sort"
            }
          ],
          "concreteType": "SearchItemConnection",
          "kind": "LinkedField",
          "name": "__SearchResultsAsyncPagination__search_connection",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isCachedResult"
            },
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "includeAssigneeField",
                  "variableName": "includeAssigneeField"
                },
                {
                  "kind": "Variable",
                  "name": "includeIconUrl",
                  "variableName": "includeIconUrl"
                },
                {
                  "kind": "Variable",
                  "name": "includeIssueTypeField",
                  "variableName": "includeIssueTypeField"
                },
                {
                  "kind": "Variable",
                  "name": "includeNavBoostScore",
                  "variableName": "includeNavBoostScore"
                },
                {
                  "kind": "Variable",
                  "name": "includePassionfruitAsk",
                  "variableName": "includePassionfruitAsk"
                },
                {
                  "kind": "Variable",
                  "name": "includePositions",
                  "variableName": "includePositions"
                },
                {
                  "kind": "Variable",
                  "name": "includeThirdPartyId",
                  "variableName": "includeThirdPartyId"
                },
                {
                  "kind": "Variable",
                  "name": "includeTotalCounts",
                  "variableName": "includeTotalCounts"
                }
              ],
              "kind": "FragmentSpread",
              "name": "searchResults_AtlassianSearchPage_SearchResultsBody_connectionData"
            },
            {
              "concreteType": "SearchResultItemEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "cursor"
                }
              ]
            },
            {
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "endCursor"
                },
                {
                  "kind": "ScalarField",
                  "name": "hasNextPage"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "6411287103a49e6fb423d59ec4feee26";

export default node;
